export default [
  {
    path: '/set-rejected-part-from-stock',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'SetRejectedPartFromStock',
        component: () => import('./containers/SetRejectedPartFromStockContainer'),
      },
    ],
  },
]
